import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import ArrowForwardSharpIcon from '@mui/icons-material/ArrowForwardSharp';
import useInterval from 'utils/useInterval';
import { getStatusData } from '../../../services/order-service';

export const LastUpdated = (props: {
  modifiedDate: string;
  status: string;
}) => {
  const [update, setUpdate] = useState(0);
  const diff = Date.now() - new Date(props.modifiedDate).getTime();

  useInterval(function() {
    setUpdate(update + 1);
  }, 10000);

  const getText = (mins: number) => {
    if (mins === 0) {
      return 'Now';
    } else if (mins < 60) {
      return `${mins} mins ago`;
    } else {
      return `${Math.trunc(mins / 60)} hrs ago`;
    }
  };
  const mins = Math.trunc(diff / 1000 / 60);
  return (
    <Box
      display={'flex'}
      alignItems="left"
      sx={{
        marginTop: 1
      }}>
      <Box
        display={'flex'}
        sx={{
          border: 1,
          borderRadius: 16,
          background: '#EFF0F6',
          borderColor: '#1B1F2426'
        }}>
        <ArrowForwardSharpIcon
          sx={{
            height: 20,
            width: 20,
            padding: '2px',
            alignContent: 'center',
            justifyContent: 'right',
            color: 'black'
          }}
        />
      </Box>
      <Typography
        noWrap
        pl={1}
        variant={'body1'}
        sx={{
          color: 'black'
        }}
        style={{ fontWeight: 400, fontSize: 12 }}>
        Moved&nbsp;
      </Typography>
      <Typography
        noWrap
        variant={'body1'}
        sx={{
          color: '#6E7191'
        }}
        style={{ fontWeight: 400, fontSize: 12 }}>
        to&nbsp;
      </Typography>
      <Typography
        noWrap
        variant={'body1'}
        sx={{
          color: 'black'
        }}
        style={{ fontWeight: 400, fontSize: 12 }}>
        {getStatusData(props.status).shortText}&nbsp;
      </Typography>
      <Typography
        noWrap
        variant={'body1'}
        sx={{
          color: '#6E7191'
        }}
        style={{ fontWeight: 400, fontSize: 12 }}>
        {getText(mins)}
      </Typography>
    </Box>
  );
};
